import { SortOrder } from "@server/models.ts";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

export const StockFilter = z.enum(["all", "out", "inactive"]);
export type StockFilter = z.infer<typeof StockFilter>;

export const RouteSearchParams = z.object({
  store: z
    .union([z.string(), z.array(z.string())])
    .optional()
    .default("all"),
  status: StockFilter.optional().default("all"),
  search: z.string().optional().default(""),
  sortOrder: SortOrder.optional().default("desc"),
});

export const Route = createFileRoute("/erp/")({
  validateSearch: RouteSearchParams,
});
